import { SVGProps } from 'react';
const SvgFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 21V5M20 15.687c-5.818 4.55-10.182-4.55-16 0V4.313c5.818-4.55 10.182 4.55 16 0v11.374Z"
    />
  </svg>
);
export default SvgFlag;
